module.exports = __webpack_public_path__ + "static/media/profile.da52bfad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/profile.png
// module id = 38
// module chunks = 0